













import Routes from '@/util/Routes';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CategoryDto } from '@/api';

@Component({
  components: {},
})
export default class ProductBreadcrumbs extends Vue {

  private routes = Routes;

  @Prop({required: true})
  public category!: CategoryDto;
}
